<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Bank Term Rate {{ (bankTermRate.name) ? (" - " + bankTermRate.name) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Bank Term Rate - {{bankTermRate.name}}</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="bankTermRate.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="bankTermRate.name" input-classes="form-control" required />
                <base-input label="Bank" required >
                    <select class="form-control" v-model="bankTermRate.bank_id">
                        <option v-for="option in bankOptions" v-bind:value="option.id" v-bind:key="option.id">
                            {{ option.name }}
                        </option>
                    </select>
                </base-input>
                <base-input label="Bank Term" required >
                    <select class="form-control" v-model="bankTermRate.bank_term_id">
                        <option v-for="option in bankTermOptions" v-bind:value="option.id" v-bind:key="option.id">
                            {{ option.name }}
                        </option>
                    </select>
                </base-input>
                <base-input alternative="" label="Commission Rate (%)" placeholder="" v-model="bankTermRate.commission_rate" input-classes="form-control" type="number" required />
                <base-input label="Effectivity Date">
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <a-date-picker v-model='bankTermRate.effectivity_date' placeholder="Effectivity Date" style="width: 100%"/>
                        </div>
                    </div>
                </base-input>
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="bankTermRate.remark" />
                </base-input>
            </div>

            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="bankTermRate" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>

            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="bankTermRate.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="bankTermRate.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="bankTermRate.remark" />
                        </base-input>
                        <base-input label="Operation" required >
                            <select class="form-control" v-model="bankTermRate.operation_type">
                                <option v-for="option in operationOptions" v-bind:value="option.key" v-bind:key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="bankTermRate" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>
            
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'

    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {

            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Bank Term Rates?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0) {
                var bank_term_rate_data = await HTTPRequest.getRequest(component_x.endPoint + 'bank_term_rates/' + component_x.profileId, null)
                if (bank_term_rate_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (bank_term_rate_data["error"] == undefined) {
                        component_x.bankTermRate = bank_term_rate_data
                    } else {
                        this.errors = bank_term_rate_data["error"].split(",")
                    }
                }
            }

            var banks = await HTTPRequest.getRequest(this.endPoint + "banks" , null, null)
            this.bankOptions = banks.data;
        
            var bank_card_terms = await HTTPRequest.getRequest(this.endPoint + "bank_card_terms" , null, null)
            this.bankTermOptions = bank_card_terms.data;

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                operationOptions: [],
                bankOptions: [],
                bankTermOptions: [],
                errors: [],
                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                bankTermRate: {
                    code: '',
                    name: ''
                },
                formErrors: []
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bankTermRate
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.bankTermRate = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.bankTermRate.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.bankTermRate.name));
                this.errors.push(ValidateField.required('Bank', this.bankTermRate.bank_id));
                this.errors.push(ValidateField.required('Bank Term', this.bankTermRate.bank_term_id));
                this.errors.push(ValidateField.required('Commission Rate', this.bankTermRate.commission_rate));
                this.errors.push(ValidateField.decimalFormat('Commission Rate', this.bankTermRate.commission_rate));
                this.errors.push(ValidateField.required('Effectivity Date', this.bankTermRate.effectivity_date));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var bank_term_ratePayload = {
                    //     bank_term_rate: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }
                    this.bankTermRate.name = this.bankTermRate.name.trim()
                    this.bankTermRate.code = this.bankTermRate.code.trim()
                    this.bankTermRate.status = 'A'
                    var bank_term_ratePayload = { bank_term_rate: this.bankTermRate }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'bank_term_rates', null, bank_term_ratePayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var bank_term_ratePayload = {
                    //     bank_term_rate: {
                    //         name: this.inputName.trim(),
                    //         code: this.inputCode.trim(),
                    //         remark: this.inputRemark,
                    //         status: 'A',
                    //         operation_type: this.inputOperation
                    //     }
                    // }

                    this.bankTermRate.name = this.bankTermRate.name.trim()
                    this.bankTermRate.code = this.bankTermRate.code.trim()
                    let status = (this.bankTermRate.status == null) ?  "A" : this.bankTermRate.status
                    this.bankTermRate.status = status
                    // this.bankTermRate.status = 'A'
                    var bank_term_ratePayload = { bank_term_rate: this.bankTermRate }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'bank_term_rates/' + this.profileId, null, bank_term_ratePayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>